import { SearchableDropdown } from './SearchableDropdown';

interface NeighborhoodDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  greaterAreaId?: string;
  disabled?: boolean;
}

export function NeighborhoodDropdown({
  value,
  onChange,
  placeholder = 'Select Neighborhood',
  className,
  greaterAreaId,
  disabled,
}: NeighborhoodDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search neighborhoods..."
      className={className}
      endpoint="neighborhoods"
      emptyText="No neighborhoods found."
      filters={greaterAreaId ? { greaterAreaId } : undefined}
      disabled={disabled}
    />
  );
}
